import { useClearCache as useApiClearCache } from '@kaiizen/kai-pro-api-react-state';
import { useCallback } from 'react';

/* Deep import, not the KaiNavigator barrel: the store is a leaf module and the
   barrel would risk a State ↔ Partials cycle. */
import { clearNavigatorExpansionSessionCache } from '@/Client/Partials/KaiNavigator/navigatorExpansionSessionCache';

/**
 * Wraps the API layer's cache clear so the in-memory navigator expansion cache —
 * a module-level singleton the API cache knows nothing about — is scrubbed at the
 * same identity boundaries (logout, impersonation, org switch) where every other
 * cache is cleared. Without this, group/contractor expansion would survive a
 * logout and login as a different user, or an impersonation/org switch.
 *
 * Shadows the `useClearCache` re-exported from `@kaiizen/kai-pro-api-react-state`
 * via the `@/Client/State` barrel, so every consumer of the barrel gets this
 * wrapper transparently.
 */
export const useClearCache = (): () => Promise<void> => {
  const clearApiCache = useApiClearCache();
  return useCallback(async () => {
    await clearApiCache();
    clearNavigatorExpansionSessionCache();
  }, [clearApiCache]);
};
